import builderPathInit from '../../../util/builder-path-init';
import { builder } from '@builder.io/react/lite';
import getConfig from 'next/config';
import { fetchFilteredArticles } from '@glowforge/builder-components/lib/util/fetchFilteredArticles'
import { removeDataBlocks } from '../../../util/remove-data-blocks'


const pathPrefix = `/blog/author`;
const model = 'blog-author';

const {
  publicRuntimeConfig: { GF_DOTCOM_ENV },
} = getConfig();

const builderComponentQuery =
  GF_DOTCOM_ENV === 'production'
    ? {
        query: {
          data: {
            environment: GF_DOTCOM_ENV ?? 'production',
          },
        },
      }
    : {};

const { BuilderPage } = builderPathInit({
  model: model,
});

export default BuilderPage;

export async function getServerSideProps(context) {
  const {
    params: { id },
  } = context;
  const urlPath = id ? `${pathPrefix}/${id}` : pathPrefix;
  const content = await builder
    .get(model, {
      userAttributes: {
        urlPath,
        ...builderComponentQuery,
      },
      options: { enrich: true, includeRefs: true },
    })
    .promise();
  if (!content) {
  return {
      notFound: true,
    };
  }
  removeDataBlocks(content.data.blocks);

  const { name } = content?.data

  const modelId = content?.id;
  const serverFiltered = await fetchFilteredArticles('author', modelId, 0, 8, undefined, true);
  
  if (serverFiltered) {
    content['data'] = {
      ...content.data,
      serverFiltered: serverFiltered,
    };
  }
  return {
    props: {
      content,
      title: name
    },
  };
}
